<template>
  <div>
    <div class="header-card">
      <div class="close-btn">
        <img src="@/assets/close.png" height="18" width="18" alt="close-icon" @click="back">
      </div>
      <div class="header-card-text">
        <h3>Save Funds</h3>
      <!--<p class="sub-text fnt-14">Use the options below to fund your Smart Stewards wallet</p>-->
      </div>
    </div>
    <div class="content">
        <div @click="openSavings(1)" class="feeds-card">
          <p>30-Days SIC Flex: 8% p/a on funds locked up for 30 days ( interest will be forfeited
            if you break your investment at any point in time before maturity).</p>
        </div>

        <div @click="openSavings(2)" class="feeds-card">
          <p>90-Day SIC Safelock: 10% p/a on fund locked up for 90 days (interest will be forfeited
            if you break your investment at any point in time before maturity).</p>
        </div>

        <div @click="openSavings(3)" class="feeds-card">
          <p>365-Day SIC Safelock: 12% p/a on funds locked up for 365 days (interest will be
            forfeited if you break your investment at any point in time before maturity).</p>
        </div>
    </div>
  </div>
</template>

<script>

export default {
  computed: {
    isDisabled() {
      if (!this.amount || (this.balance < this.amount)) {
        return true;
      }
      return false;
    },
  },
  data() {
    return {
      status: '',
      amount: '',
      loading: false,
      pageLoading: true,
    };
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
    openSavings(plan) {
      this.$router.push(`/savings/${plan}/plan`);
    },
  },
};
</script>

<style lang="scss" scoped>
  a{
    color: #EE0E4C;
    font-weight: 400;
  }
  p {
    margin-bottom: .25rem;
  }
  .account_balance{
    margin: 0 0 1rem 0;
    background-color: #EE0E4C;
    color: #FFF;
    padding: 1rem;
    text-align: center;
    font-size: 20px;
    line-height: 1.5;
    border-radius: 8px;
  }
  .trans-table{
    padding: 1rem;
    border-radius: 8px;
    background-color: #FFF;
    &-row{
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: .75rem 0;
      border-bottom: 1px solid #E5E5E5;
      &:last-child{
        border-bottom: none;
      }
    }
    .row1{
      .p1{
        font-size: 11px;
        line-height: 12px;
        color: #49566A;
        font-family: 'Cabin', sans-serif;
      }
    }
    .row2{
      p{
        font-family: 'Cabin', sans-serif;
        font-weight: 600;
        font-size: 16px;
      }
    }
  }
  .transactions{
    margin-top: 1rem;
  }
  form{
    margin-bottom: 2rem;
  }
  .notification{
    text-align: center;
    font-family: 'Cabin', sans-serif;
    font-weight: 600;
    font-size: 16px;
    // margin-top: 2rem;
    p{
      margin-bottom: 1rem;
    }
  }
  .loadingText{
    font-size: 20px;
  }
  .success-label{
    background-color: rgba($color: #50A948, $alpha: 0.2);
    color: #50A948;
    padding: .25rem;
    border-radius: 8px;
    font-size: 10px;
    font-weight: 700;
    text-align: center;
  }
  .process-label{
    background-color: #FFDDE6;
    color: #EE0E4C;
    padding: .25rem;
    border-radius: 8px;
    font-weight: 400;
    font-size: 11px;
    text-align: center;
  }
  .empty-trans{
    margin-top: 2rem;
    text-align: center;
    color: #6b6b6b;
  }
  .feeds-card{
    padding: 1rem;
    background-color: #EE0E4C;
    color: #FFF;
    font-family: 'Open Sans', sans-serif !important;
    font-weight: bold;
    height: auto;
  }
</style>
